
// _styles.scss media breakpoints (px)
const breakpoint = {
    sm: 470,
    smMd: 550,
    md: 768,
    lg: 992,
    xl: 1020,
    xxl: 1200,
};

export { breakpoint };